import { DEFAULT_CURRENCY_FORMAT, formatNumber } from 'core/common/utils/numberUtils';
import { LovItem } from 'core/metamodel/mdEntity';
import { INVOICEPAYMENTMATCHTYPE } from 'invoice/domain/invoiceDomain';
import { ID } from 'core/metamodel/metaConstant';
import { DomainAncestor, entityConfig } from 'core/common/domain/DomainAncestor';
import { lovValue } from 'core/form/formUtils';
import { observable } from 'mobx';
import { Price } from 'product/productDomain';


export enum BANKTRANSACTIONTYPE {
  PAYMENT_IN = "PAYMENT_IN",
  PAYMENT_OUT = "PAYMENT_OUT",
  STANDINGORDER = "STANDINGORDER",
  DIRECTDEBIT = "DIRECTDEBIT",
  CARDPAYMENT = "CARDPAYMENT",
  CASHPAYMENT = "CASHPAYMENT",
  FEE = "FEE",
  INTEREST = "INTEREST",
  OTHER = "OTHER",
}

@entityConfig()
export class BankTransaction extends DomainAncestor {

  @observable bankTransactionId: number;
  @observable account: LovItem;
  @observable valueDate: string | Date;
  @observable amount: number;
  @observable currency: string;
  @observable comment: string;
  @observable bankReference: string;
  @observable counterPartyAccountNo: string;
  @observable counterPartyAccountName: string;
  @observable counterPartyBankCode: string;
  @observable counterPartyBankName: string;
  @observable bic: string;
  @observable transactionType: LovItem;
  @observable fioType: string;
  @observable vs: string;
  @observable ss: string;
  @observable ks: string;
  @observable userReference: string;
  @observable messageForBeneficiary: string;
  @observable description: string;
  @observable executedBy: string;
  @observable counterParty: LovItem;
  @observable timeOfInvoiceMatch: string | Date;


  constructor(json: any) {
    super(json);
  }

  public fromJson(json: any): this {
    super.fromJson(json);

    return this;
  }


  public getId(): ID {
    return this.bankTransactionId;
  }

  public setId(id: ID): void {
    this.bankTransactionId = <any>id;
    this.id = id;
  }

  public getFullAmount(): string {
    return formatNumber(this.amount, DEFAULT_CURRENCY_FORMAT) + " " + lovValue(this.currency);
  }

}


@entityConfig()
export class PartyCreditEntry extends DomainAncestor {

  @observable creditEntryId: number;
  @observable party: LovItem;
  @observable valueDate: string | Date;
  @observable amount: number;
  @observable currency: LovItem;
  @observable comment: string;
  @observable paymentType: LovItem;
  @observable creditNote: LovItem;
  @observable bankTransaction: LovItem;
  @observable invoicePayment: LovItem;
  @observable matchType: INVOICEPAYMENTMATCHTYPE;


  constructor(json: any) {
    super(json);
  }

  public fromJson(json: any): this {
    super.fromJson(json);

    return this;
  }


  public getId(): ID {
    return this.creditEntryId;
  }

  public setId(id: ID): void {
    this.creditEntryId = <any>id;
    this.id = id;
  }

  public getFullAmount(): string {
    return formatNumber(this.amount, DEFAULT_CURRENCY_FORMAT) + " " + lovValue(this.currency);
  }

}


export interface PartyCreditEntryDto {
  entries: PartyCreditEntry[];
  sums: Price[];
}




// WEBPACK FOOTER //
// ./src/accounting/accountingDomain.ts